export const flow = {
	title: "Extracto-Flujo de Caja",
	filename: "extracto-flujo-de-caja",
	emptyText: "No hay nada que mostrar para el período seleccionado",
	anticipated: "Anticipado",
	table: {
		date: "Fecha de liquidación",
		competency: "Fecha de transacción",
		title: "Descripción",
		value: "Valor",
		balance: "Saldo",
	},
};
